import React, { useEffect, useState } from 'react'
import SingleSignOnSideBar from '../../Components/SingleSignOnSideBar'
import Header from '../../Components/Header'
import { Constants } from '../../CommonMethhods/Constants';
import { AESEncryption, ApiResDecrypt, checkDateRange, compareDate } from '../../CommonMethhods/CommonMethods';
import axios from 'axios';
import { CLIENT_FNO, Client_Search, Dashboard_Client_Report } from '../../Configuration/API_URL';
import $ from "jquery";
import TodateComponent from '../Reports/TodateComponent';
import FromdateComponent from '../Reports/FromdateComponent';
import LoaderForSearch from '../../Components/Common/LoaderForSearch';
import ClientFnoLossTable from './ClientFnoLossTable';
import { toast } from 'react-toastify';
import moment from 'moment';
import Select from "react-select";
import { useDebounce } from '../../Components/useDebounce';

export default function ClientFnoLoss(props) {
    const [fromDate, setFromDate] = useState("");
    const [toDate, setToDate] = useState("");
    const [clientList, setClientList] = useState([]);
    const [scroll, setScroll] = useState(false);
    const [clientName, setClientName] = useState("");
    const [clientCode, setClientCode] = useState("");
    const [serverError, setServerError] = useState("");
    const [scrollLoader, setScrollLoader] = useState(false);
    const [page, setPage] = useState(1);
    const [errorResp, setErrorResp] = useState("");
    const [errorRespYe, setErrorRespYe] = useState("");
    const [errorRespMo, setErrorRespMo] = useState("");

    const [nameError, setNameError] = useState("");
    const [gridVal, setGridVal] = useState("");
    const [loader, setLoader] = useState(false);
    const [smallLoaderExcel, setSmallLoaderExcel] = useState(false);
    const [smallLoaderPdf, setSmallLoaderPdf] = useState(false);
    const [clientNameError, setClientNameError] = useState(false);
    const [pageTable, setPageTable] = useState(1)
    const [count, setCount] = useState()
    const [scrollLoaderTable, setScrollLoaderTable] = useState(false)
    const storeToken = localStorage.getItem("ssoToken");
    const currentYear = new Date().getFullYear();

    const debouncedValue = useDebounce(clientName, 1000);
    
      useEffect(() => {
        handleClientName(debouncedValue);
      }, [debouncedValue]);

    // Create array of last 10 years


    const [selectedYear, setSelectedYear] = useState(null);
    const options = [
        { value: "JAN", label: "January" },
        { value: "FEB", label: "February" },
        { value: "MAR", label: "March" },
        { value: "APR", label: "April" },
        { value: "MAY", label: "May" },
        { value: "JUN", label: "June" },
        { value: "JUL", label: "July" },
        { value: "AUG", label: "August" },
        { value: "SEP", label: "September" },
        { value: "OCT", label: "October" },
        { value: "NOV", label: "November" },
        { value: "DEC", label: "December" },
    ];

    const [selectedMonth, setSelectedMonth] = useState(null);
    console.log(selectedMonth, "selectedMonth");
    const [yearDataList, setYearDataList] = useState([])
    useEffect(() => {
        if (selectedMonth) {
            getYears()
        } else {
            return
        }
    }, [selectedMonth])
    async function getYears() {
        let payload = {
            "month": selectedMonth.value
        }
        console.log(payload, "payload");

        let encPayload = AESEncryption(payload);
        try {
            const getYearList = await axios.post(
                   CLIENT_FNO.getfnolossyear,
                // 'https://uat-cosmos.bajajfinservsecurities.in/api/rm/fnoloss/getfnolossyear',
                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );
            const res = ApiResDecrypt(getYearList?.data);
            console.log(res, "yeardata");
            if (res.status == 0) {
                setYearDataList(res.data)
            } else {
                console.log("no data");

            }

        } catch (err) {

        }
    }
    console.log(yearDataList, "yearDataList");

    const optionsYear = yearDataList.map((year) => ({
        value: year,
        label: year.toString(),
    }));

    async function searchApiDetail(e) {
        $(".write-search.clientfno").addClass("show-result scroll-table");
        let payloadValue = {
            keyword: e.toUpperCase(),
            Status: "",
            PageNo: page,
            PageSize: 10,
        };
        let encPayload = AESEncryption(payloadValue);
        try {
            const getSearchDetail = await axios.post(
                Client_Search.Search_URL,

                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );

            const res = ApiResDecrypt(getSearchDetail?.data);

            if (res.message === "Client does not exist.") {
                setClientList([
                    { clientname: "Client does not exist.", clientCode: null },
                ]);
            } else {
                if (scroll == true) {
                    setClientList((prev) => {
                        return [...prev, ...res.data.clients];
                    });
                    setServerError("");
                } else {
                    setClientList(res.data.clients);
                    setServerError("");
                }
            }
        } catch (error) {
            console.log(error);
        } finally {
            setScrollLoader(false);
        }
    }
    function clientSet(name, code, i) {
        if (name === "Client does not exist.") {
            setClientCode("")
            $(".write-search.clientfno").addClass("show-result scroll-table");
        } else {
            $(".write-search.clientfno").removeClass("show-result");
            setClientList([]);
            setClientName(name);
            setClientCode(code);
            setScrollLoader(false);
        }
    }

    const handleClientName = (data) => {
        setScrollLoader(false);
        // setFileType("");
        console.log("handle client name", data)
        if (data) {
            setClientList([]);
            setScroll(false);
            // let result = data.toUpperCase();
            // setClientName(result);
            if (data?.length > 3) {
                setPage(1);
                setClientList([]);
                setScroll(false);
                searchApiDetail(data);
            }
        } else {
            // setFileType("");
            setClientCode("")
            setClientList([]);
            setPage(1);
            setClientName("");
            setScroll(false);
            $(".write-search.clientfno").removeClass("show-result");
        }
        $(".write-search.clientfno-li").click(function () {
            $(".write-search.clientfno").addClass("show-result scroll-table");
        });
    };
    const handleScroll = async () => {
        setScroll(true);
        const a = document.querySelector("#clientfno-scroll");
        if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
            setPage((prev) => prev + 1);
            setScrollLoader(true);
            searchApiDetail(clientName);
        }
    };

    const getClientFno = async (fileType, rmCode, pageSize = 5, offset) => {
        if (fileType === "grid" && offset > 1) {
            setLoader(false)
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
        }
        else if (fileType == "excel") {
            setSmallLoaderExcel(true);
            setSmallLoaderPdf(false);
            setLoader(false);
        } else if (fileType == "pdf") {
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(true);
            setLoader(false);
        } else {
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
            setLoader(true)
        }
        let payloadValue = {
            clientCode: clientCode,
            month: selectedMonth?.value ? selectedMonth?.value : "",
            year: selectedYear?.value ? selectedYear?.value : 0,
            searchBy: rmCode,
            fileType: fileType,
            pageSize: pageSize,
            pageNo: offset,
        };
        console.log("payloadValue", payloadValue)
        let encPayload = AESEncryption(payloadValue);
        try {
            const getDetails = await axios.post(
                CLIENT_FNO.Get_Client_FnO,
                `"${encPayload}"`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${storeToken}`,
                        reserv: 1,
                    },
                }
            );
            const res = ApiResDecrypt(getDetails?.data);
            console.log("res client fno", res)
            if (res?.data) {
                if (fileType == "grid") {
                    setCount(res?.data?.totalCount)
                    if (offset > 1) {
                        setGridVal((prev) => {
                            return [...prev, ...res?.data?.fnoLossDetails];
                        })
                    } else {
                        setGridVal(res?.data?.fnoLossDetails);

                    }
                    // setGridVal(res?.data);
                } else if (fileType == "excel") {
                    window.open(res?.data, "_self", "noopener,noreferrer");
                } else if (fileType == "pdf") {
                    window.open(res?.data, "_blank", "noopener,noreferrer");
                }

            } else {
                setGridVal([]);
                if (fileType == "excel") {
                    toast.error("Client F&O Report does not exist.");
                } else if (fileType == "pdf") {
                    toast.error("Client F&O Report does not exist.");
                }
            }
            setClientNameError(false);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);
            setScrollLoaderTable(false)
        } catch (error) {
            console.log(error);
            setLoader(false);
            setSmallLoaderExcel(false);
            setSmallLoaderPdf(false);

            setServerError("Something went wrong, Please try again later.");
            if (fileType == "excel") {
                toast.error("Something went wrong, Please try again later.");
            }
            if (fileType == "pdf") {
                toast.error("Something went wrong, Please try again later.");
            }

        }
    };

    useEffect(() => {
        getClientFno("grid", "", 5, 1)
    }, [])

    const currentDate = new Date();
    const yyyy = currentDate.getFullYear();
    let mm = currentDate.getMonth() + 1;
    let dd = currentDate.getDate();
    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;
    const FormatedDate = dd + "/" + mm + "/" + yyyy;
    const DateReverse = FormatedDate.split("/").reverse().join("-");

    const handleDownloadBtn = () => {
        getClientFno("excel", "", -1, -1)
    }
    const handleFromDateChange = (e) => {
        if (e.target.value) {
            // setFileType("");
            setGridVal("");
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setFromDate(d);
            setErrorResp("");
            setServerError("");
        }
        else {
            setFromDate("")
            setErrorResp("");
            setServerError("");
        }
    };
    const handleToDateChange = (e) => {
        if (e.target.value) {
            setGridVal("");
            let c = e.target.value;
            const d = moment(c, "YYYY-MM-DD").format("MM-DD-YYYY");
            setToDate(d);
            setErrorResp("");
            setServerError("");
        }
        else {
            setToDate("")
            setErrorResp("");
            setServerError("");
        }

    };
    function formatDate(date) {
        return moment(date, "MM-DD-YYYY").format("YYYY-MM-DD");
    }

    console.log("from date", fromDate, toDate)
    const handleOnClick = (e) => {
        setPageTable(1)
        console.log("Clicked", e.target.value, selectedYear, selectedMonth, clientCode);
        if ((selectedMonth && selectedYear == 0)) {
            setErrorRespYe("Year is Required");
            return;
        }
        if ((selectedMonth == 0 && selectedYear)) {
            setErrorRespMo("Month is Required");
            return
        }
        // debugger
        if (clientCode && (!selectedYear && !selectedMonth)) {
            getClientFno("grid", "", 5, 1);
        }
        else if (!clientCode && (fromDate || toDate)) {
            if (compareDate(fromDate) && compareDate(toDate) && checkDateRange(fromDate, toDate)) {
                getClientFno("grid", "", 5, 1);
            } else {
                setErrorResp("Please enter a valid date range");
            }
        }
        else if (clientCode && (fromDate || toDate)) {
            if (compareDate(fromDate) && compareDate(toDate) && checkDateRange(fromDate, toDate)) {
                getClientFno("grid", "", -1, -1);
            } else {
                setErrorResp("Please enter a valid date range");
            }
        }
        else if (!clientCode && !fromDate && !toDate) {
            setFromDate("");
            setToDate("");
            setClientCode("");
            getClientFno("grid", "", 5, 1)
        }
    };
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: "none",
            border: "1px solid #ccc",
            "&:hover": {
                border: "1px solid #ccc",
            },
        }),
    };
    const customStylesYears = {
        control: (provided, state) => ({
            ...provided,
            boxShadow: "none",
            border: "1px solid #ccc",
            "&:hover": {
                border: "1px solid #aaa",
            },
        }),
    };
    return (
        <div>
            <Header title={props.title} portal={"RM"} />
            <SingleSignOnSideBar />
            <main id="main-content" className='client-fno'>
                <div className="card-box">
                    <div className="row input-field-wrapper">
                        <div className="col-md-3 col-sm-3 col-12">
                            <div className="form-group">
                                <label className="form-label">{Constants.Client_Name}</label>
                                <div className="input-text-wrapper align-items-center">
                                    <input
                                        style={{ height: "38px" }}
                                        id="input1"
                                        type="text"
                                        className="input-text form-control"
                                        placeholder="Search by Name/ Code"
                                        value={clientName}
                                        // onChange={(e) => {
                                        //     handleClientName(e);
                                        // }}
                                        onChange={(e) => {
                                        setClientName(e.target?.value?.toUpperCase());
                                        }}
                                        onInput={(e) => {
                                            const start = e.target.selectionStart;
                                            const end = e.target.selectionEnd;

                                            let input = e.target.value.toUpperCase();
                                            input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                                                    input = input.replace(/\s{2,}/g, " "); 
                                                    input = input.replace(/^\s+/, ""); 

                                            if (input.length > 100) input = input.slice(0, 100);
                                            e.target.value = input;
                                            e.target.setSelectionRange(start, end);
                                            }}
                                    />

                                    <ul
                                        className="write-search clientfno border-0"
                                        id="clientfno-scroll"
                                        onScroll={handleScroll}
                                    >
                                        {clientList.map((item, i) => (
                                            <li
                                                key={i}
                                                onClick={() =>
                                                    clientSet(item.clientname, item.clientCode, i)
                                                }
                                            >
                                                <div> {item.clientname}</div>
                                                <div>{item.clientCode}</div>
                                            </li>
                                        ))}
                                        {scrollLoader && (
                                            <div className="loader-center">
                                                <LoaderForSearch />
                                            </div>
                                        )}
                                    </ul>
                                </div>

                            </div>
                        </div>
                        <div class="form-group" style={{ width: "290px" }}>
                            <label className="form-label">Select Month:</label>
                            <Select
                                options={options}
                                value={selectedMonth}
                                onChange={(value) => {
                                    setSelectedMonth(value);
                                    setErrorRespMo("");
                                    setSelectedYear([])
                                }}
                                placeholder="Search month..."
                                isSearchable={true}
                                styles={customStyles}
                                onInputChange={(value, action) => {
                                    if (action.action === "input-change") {

                                    let input = value.toUpperCase();
                                    input = input.replace(/[^A-Z\s]/g, "");   // allow A–Z + space
                                    input = input.replace(/\s{2,}/g, " ");    // no double space
                                    input = input.replace(/^\s+/, "");        // no leading space
                                    input = input.slice(0, 15);               // limit length

                                    return input; // MUST return cleaned value
                                    }
                                    return value;
                                }}
                            />
                            {errorRespMo && (
                                <span className="to-date-error month-error">{errorRespMo}</span>
                            )}
                        </div>
                        {selectedMonth &&
                            <div class="form-group" style={{ width: "290px" }}>
                                <label className="form-label">Select Year:</label>
                                <Select
                                    options={optionsYear}
                                    value={selectedYear}
                                    onChange={(value) => {
                                        setSelectedYear(value);
                                        setErrorRespYe("");
                                    }}
                                    placeholder="Search year..."
                                    isSearchable={true}
                                    styles={customStylesYears}
                                    onInputChange={(value, action) => {
                                        if (action.action === "input-change") {
                                        let input = value;
                                        input = input.replace(/[^0-9]/g, "");
                                        input = input.slice(0, 4);
                                        return input;
                                        }

                                        return value;
                                    }}
                                />
                                {errorRespYe && (
                                    <span className="to-date-error month-error" >{errorRespYe}</span>
                                )}
                            </div>
                        }


                    </div>
                    <div className="text-center search-btn-wrapper">
                        <button
                            value="grid"
                            className="send-message"
                            onClick={handleOnClick}
                        >
                            {Constants.Search}
                        </button>
                    </div>
                    <ClientFnoLossTable
                        gridVal={gridVal}
                        smallLoaderExcel={smallLoaderExcel}
                        loader={loader}
                        setLoader={setLoader}
                        setScrollLoaderTable={setScrollLoaderTable}
                        scrollLoaderTable={scrollLoaderTable}
                        count={count}
                        getClientFno={getClientFno}
                        handleDownloadBtn={handleDownloadBtn}
                        setPageTable={setPageTable}
                        pageTable={pageTable} />
                </div>
            </main>

        </div>
    )
}
